import { Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { trigger, style, transition, animate } from "@angular/animations";

@Component({
  selector: "ds-text-accordion-item",
  templateUrl: "./ds-text-accordion-item.component.html",
  styleUrls: ["./ds-text-accordion-item.component.scss"],
  animations: [
    trigger("slideDown", [
      transition(":enter", [
        style({ height: "0px", overflow: "hidden" }),
        animate("200ms ease-in-out", style({ height: "*" })),
      ]),
      transition(":leave", [
        style({ height: "*", overflow: "hidden" }),
        animate("200ms ease-in-out", style({ height: "0px" })),
      ]),
    ]),
  ],
})
export class DsTextAccordionItemComponent {
  @Input() label!: string;
  @Input() body!: string;
  @Input() disabled: boolean = false;
  @Input() isOpen: boolean = false;
  @Input() collapse: boolean = true;

  @Output() opened = new EventEmitter<DsTextAccordionItemComponent>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes["disabled"]) {
      this.isOpen = false;
    }
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.opened.emit(this);
    }
  }

  close() {
    if (this.collapse) {
      this.isOpen = false;
    }
  }
}
